import * as requests from "../coraWebComponents/utils/requests";
import Urls from "../constants/Urls";

export const addOdberatel = async (data) => {
  try {
    let res = await requests.post(Urls.AddOrgan, data);
    return res;
  } catch (error) {
    throw error;
  }
};

export const updateUser = async (data) => {
  try {
    return await requests.post(Urls.UpdateUser, data);
  } catch (error) {
    throw error;
  }
};

